/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchManagerRequest
 */
export interface SearchManagerRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchManagerRequest
     */
    query: string;
}

/**
 * Check if a given object implements the SearchManagerRequest interface.
 */
export function instanceOfSearchManagerRequest(value: object): value is SearchManagerRequest {
    if (!('query' in value) || value['query'] === undefined) return false;
    return true;
}

export function SearchManagerRequestFromJSON(json: any): SearchManagerRequest {
    return SearchManagerRequestFromJSONTyped(json, false);
}

export function SearchManagerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchManagerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'query': json['query'],
    };
}

export function SearchManagerRequestToJSON(value?: SearchManagerRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'query': value['query'],
    };
}

